<template>
  <article v-bind:class="{ good: notthatmuch }">
    <h1>{{ title }}</h1>
    <p><slot></slot></p>
  </article>
</template>

<style scoped>
  article {
    border-radius: 1rem;
    background-color: #ff5d1b;
    text-align: center;
    padding: 1rem 0;
  }

  article.good {
    background-color: #a3ff65;
  }

  h1 {
    text-decoration: underline;
    font-weight: bold;
  }
</style>

<script>
// @ is an alias to /src

export default {
  name: 'ICry',

  props: {
    "title": String,
    "content": String,
    "notthatmuch": Boolean,
  },

  methods: {
  },
}
</script>
